import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "neighborhood-list-contentwrapper" }
const _hoisted_2 = { class: "neighborhood-list-communityname" }
const _hoisted_3 = { class: "neighborhood-list-desc" }
const _hoisted_4 = {
  key: 0,
  class: "neighborhood-list-single"
}
const _hoisted_5 = {
  key: 1,
  class: "neighborhood-list-price"
}

import { computed, toRefs } from "vue";
import LazyImage from "./LazyImage.vue";
import {
  NeighboorhoodCoords,
  NeighborhoodPlatMap,
  NeighborhoodSoldDetails,
  Sibling,
} from "../types";
import { ImageWidth, Scalers, ModalType } from "../constant";
import {
  addImageScaler,
  formatPrice as formatPriceUtil,
  getCentrePoint,
  getZoomLevel,
} from "@/core";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeaderNeighborhoodListItem',
  props: {
    coordinates: {},
    sibling: {},
    selectedNeighborhoodIds: {},
    neighborhoodSoldPercentage: {},
    neighborhoodLotsCount: {},
    soldPercentage: {},
    isComingSoon: { type: Boolean }
  },
  emits: ["sethoverNeighborZoomLevel", "selectNeighborhood", "hideSibling", "highlightNeighborhood"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  coordinates,
  sibling,
  selectedNeighborhoodIds,
  neighborhoodSoldPercentage,
  neighborhoodLotsCount,
  soldPercentage,
  isComingSoon,
} = toRefs(props);
const emit = __emit;

const addScaler = (url: string) =>
  addImageScaler(url, Scalers.TN, ImageWidth.TN);

const formatPrice = (price: number) => formatPriceUtil(price);

const selectNeighborhood = () => {
  if (neighborhoodLotsCount.value > 0) {
    emit("selectNeighborhood", sibling.value.id);
  }
};

const bestZoomClickNeighbor = () => {
  const hoveredNeighborhoodCoorfinates = coordinates.value?.find(
    (el) => el.id === sibling.value.id
  );
  const selectedNeighborhoodCoordinates = coordinates.value?.find(
    (el) => el.id === selectedNeighborhoodIds.value[0]
  );
  if (
    hoveredNeighborhoodCoorfinates &&
    selectedNeighborhoodCoordinates &&
    hoveredNeighborhoodCoorfinates.id !== selectedNeighborhoodCoordinates.id
  ) {
    const coordintes = [
      {
        latitude: hoveredNeighborhoodCoorfinates.latitude,
        longitude: hoveredNeighborhoodCoorfinates.longitude,
      },
      {
        latitude: selectedNeighborhoodCoordinates.latitude,
        longitude: selectedNeighborhoodCoordinates.longitude,
      },
    ];
    const mapSize = document.getElementsByClassName(
      "vue-map-container"
    )[0] as HTMLElement;
    const zoomLevel = getZoomLevel(
      coordintes,
      mapSize.clientWidth,
      mapSize.clientHeight
    );
    const center = getCentrePoint(coordintes);
    emit("sethoverNeighborZoomLevel", {
      zoomLevel,
      isDisableHoverNeighbor: false,
      centerMap: center,
    });
  }
};

const highlightHoveredNeighborhood = () => {
  bestZoomClickNeighbor();
  const overlay = document.getElementById("Overlay-Rectangle");
  if (overlay) overlay.style.display = "flex";

  soldPercentage.value.forEach((neighborhood) => {
    const element = document.getElementById(neighborhood.neighborhoodId);
    if (element) {
      if (neighborhood.neighborhoodId === sibling.value.id) {
        element.style.display = "flex";
        emit("highlightNeighborhood", {
          neighborhoodId: neighborhood.neighborhoodId,
          display: "flex",
        });
      } else {
        element.style.display = "none";
        emit("highlightNeighborhood", {
          neighborhoodId: neighborhood.neighborhoodId,
          display: "none",
        });
      }
    }
  });
};

const deselectNeighborhood = () => {
  const svg = document.getElementById("Overlay-Rectangle");
  if (svg) svg.style.display = "none";

  emit("sethoverNeighborZoomLevel", {
    zoomLevel: 0,
    isDisableHoverNeighbor: true,
    centerMap: { latitude: 0, longitude: 0 },
  });
  emit("hideSibling");
};

const neighborhoodPriceShow = computed(
  () =>
    !!+sibling.value.starting_price &&
    !isComingSoon.value &&
    neighborhoodSoldPercentage.value !== 100
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'neighborhood-list',
      {
        'is-selected':
          _unref(selectedNeighborhoodIds).includes(_unref(sibling).id) &&
          !(!_unref(neighborhoodLotsCount) || _unref(neighborhoodLotsCount) <= 0),
      },
      { 'coming-soon': _unref(isComingSoon) },
      { disabled: !_unref(neighborhoodLotsCount) || _unref(neighborhoodLotsCount) <= 0 },
    ]),
    onClick: selectNeighborhood
  }, [
    _createElementVNode("div", null, [
      _createVNode(LazyImage, {
        class: "dsize",
        src: addScaler(_unref(sibling).thumbnail_url),
        alt: _unref(sibling).neighborhood_name,
        isNeighborhoodImage: true
      }, null, 8, ["src", "alt"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(sibling).neighborhood_name), 1),
      _createElementVNode("div", _hoisted_3, [
        (_unref(sibling).home_type)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(sibling).home_type), 1))
          : _createCommentVNode("", true),
        (neighborhoodPriceShow.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _cache[0] || (_cache[0] = _createTextVNode(" Starts From ", -1)),
              _createElementVNode("strong", null, _toDisplayString(formatPrice(Number(_unref(sibling).starting_price))), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})